import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { ProgramService } from '../../../services/program.service';
import { FinancialsService } from '../../../services/financials.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-tryout-financials',
  templateUrl: './tryout-financials.component.html',
  styleUrls: ['./tryout-financials.component.css'],
  providers: [DatePipe]
})

export class TryoutFinancialsComponent implements OnInit {
  public routeParams;
  public memberNames = [];
  public TransactionDetails = [];
  public memberNamesArray = [];
  public NoOfSelectedMembers: number;
  public loadingIndicator = true;
  public selectedRecordIndex?= [];
  public isSelectAllCheckBox = false;
  public isCheckAllCheckBox = false;
  public showQuickInfo: boolean;
  public eventScheduler = [];
  public selectedDate: Date = new Date(2018, 11, 20);
  public monthlyOverviewOccupancys = [];
  public totalCollectedFees = [];
  public selectedEventCategory;
  public scheduleData;
  public TotalEarnings: number;
  public RemainingEarnings: number;
  public PastDue: number;
  public DiscountScholarships: number;
  public TodayDeposits: number;
  public ThisMonthsDeposits: number;
  public PercentageIncrease: number;

  constructor(private fb: FormBuilder,
    private datepipe: DatePipe,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private activeRoute: ActivatedRoute,
    private programService: ProgramService,
    private financialsService: FinancialsService) {
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    this.getClubProgramIncomeCounter();
    this.getTransactionDetails();
    this.getTotalCollectedFees();
  }

  refreshFinacialAnalytics() {
    this.getTotalCollectedFees();
  }

  getClubProgramIncomeCounter() {
    let programId = this.routeParams.id;
    this.financialsService.getFinancialsTopFourCounts(programId).subscribe((data: any) => {
      this.TotalEarnings = data.totalIncome;
      this.RemainingEarnings = data.remainingIncome;
      this.PastDue = data.totalPastDue;
      this.DiscountScholarships = data.totalDiscountsOrScholarships;
      this.TodayDeposits = data.todaysIncome;
      this.ThisMonthsDeposits = data.thisMonthIncome;
      this.PercentageIncrease = +data.thisMonthIncome === 0 ? 0 : Math.round((data.todaysIncome / data.thisMonthIncome) * 100);
    });
  }

  getTransactionDetails() {
    let programId = this.routeParams.id;
    this.financialsService.getTransactionDetails(programId).subscribe((data) => {
      this.TransactionDetails = data;
    }, error => {
      console.log(error);
    });
  }

  getTotalCollectedFees() {
    let programId = this.routeParams.id;
    this.financialsService.getTotalCollectedFees(programId).subscribe((data) => {
      this.totalCollectedFees = data;
    }, error => {
      console.log(error);
    });
  }

  selectAll() {
    if (this.isSelectAllCheckBox) {
      this.isSelectAllCheckBox = false;
      this.isCheckAllCheckBox = false;
      this.selectedRecordIndex.length = 0;
    } else {
      this.isSelectAllCheckBox = true;
      this.isCheckAllCheckBox = true;
      const l = this.TransactionDetails.length;
      for (let i = 0; i < l; i++) {
        this.selectedRecordIndex.push(this.TransactionDetails[i].clubprogramquestionID);
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-financials/tryout-financials.component.ts